/* header=》设置=》
  频道信息、权限信息、系统配置、机构配置 接口数据
*/
import axios from 'axios'
import { ihConfigUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 查询所有的系统配置子类别 子table
export function getOPERATION(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyValue/' + params.id
  return axios({
    method: 'get',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '查询所有的系统配置子类别', res)
    }
    return Promise.resolve(res.data)
  })
}

// 检查参数配置是否重复
export function getCheckKey(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyValue/checkKey'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '检查参数配置是否重复', res)
    }
    return Promise.resolve(res.data)
  })
}
// 查询后台操作记录中文json
export function operationMap(params) {
  const url = ihConfigUrl + '/sysProperty/operation/map'
  return axios({
    method: 'get',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '查询后台操作记录中文json', res)
    }
    return Promise.resolve(res.data)
  })
}
// 查询对讲频道,分页查询
export function getChannelList(params) {
  const url = ihConfigUrl + '/channel'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '查询对讲频道', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加或更新对讲频道
export function addChannel(params) {
  const url = ihConfigUrl + '/channel'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '添加或更新对讲频道', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据频道id删除频道信息
export function deleteChannel(params) {
  const url = ihConfigUrl + '/channel/' + params.id
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '根据频道id删除频道信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 获所有取频道列表不分页
export function getChannels() {
  const url = ihConfigUrl + '/channels'
  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '获所有取频道列表不分页', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 安全帽权限信息接口
 *  查询安全帽权限,分页查询
 */
export function getHelmetPermission(params) {
  const url = ihConfigUrl + '/helmetPermission'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '查询安全帽权限', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加或更新安全帽权限信息
export function addHelmetPermission(params) {
  const url = ihConfigUrl + '/helmetPermission'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '添加或更新安全帽权限信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据频道id删除频道信息
export function deleteHelmetPermission(params) {
  const url = ihConfigUrl + '/helmetPermission/' + params.id
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(result => {
    if (result.status !== 200 || (!!result.data && result.data.state !== 0)) {
      errorCollection('通信配置', '根据频道id删除频道信息', result)
    }
    return Promise.resolve(result.data)
  })
}
/**
 * 系统配置接口
 * 系统参数配置信息,分页结果 一级table
 */
export function getSysPropertyCodes(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyCodes'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '查询系统参数配置信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加系统配置类别 一级table
export function addSysPropertyCode(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyCode'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '添加系统配置类别', res)
    }
    return Promise.resolve(res.data)
  })
}
// 根据系统配置类别删除系统参数配置信息 一级table
export function deleteSysPropertyCode(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyCode/' + params.id
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '根据系统配置类别删除系统参数配置信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加系统配置子类别 子table
export function addChildSysProperty(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyValue'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '添加系统配置子类别', res)
    }
    return Promise.resolve(res.data)
  })
}
// 编辑系统配置子类别 子table
export function editChildSysProperty(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyValue'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '编辑系统配置子类别', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除子类别信息 子table
export function deleteChildSysProperty(params) {
  const url = ihConfigUrl + '/sysProperty/sysPropertyValue'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('参数配置', '删除子类别信息', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * wifi热点信息查询资源接口
 * 分页查询Wifi热点信息
 */
export function getWifiNetwork(params) {
  const url = ihConfigUrl + '/wifiNetwork'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '分页查询Wifi热点信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加或更新WiFi热点信息
export function addWifiNetwork(params) {
  const url = ihConfigUrl + '/wifiNetwork'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '添加WiFi热点信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 更新WiFi热点信息
export function editWifiNetwork(params) {
  const url = ihConfigUrl + '/wifiNetwork'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '更新WiFi热点信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除WiFi热点
export function deleteWifiNetwork(params) {
  const url = ihConfigUrl + '/wifiNetwork'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '删除WiFi热点', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 联系人接口
 * 分页查询联系人信息
 */
export function getContact(params) {
  const url = ihConfigUrl + '/contact'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '联系人接口', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加或更新联系人信息
export function addContact(params) {
  const url = ihConfigUrl + '/contact'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '添加或更新联系人信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除联系人信息
export function deleteContact(params) {
  const url = ihConfigUrl + '/contact/' + params.id
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '删除联系人信息', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 机构频道关联
 * 新增机构频道关联
 */
export function addOuChannel(params) {
  const url = ihConfigUrl + '/ouChannel'
  return axios({
    method: 'post',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '新增机构频道关联', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除机构频道关联
export function deleteOuChannel(params) {
  const url = ihConfigUrl + '/ouChannel'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '删除机构频道关联', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 机构配置管理权限接口
 * 分页查询机构安全帽权限信息
 */
export function getOuHelmetPermiss(params) {
  const url = ihConfigUrl + '/ouHelmetPermissions'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '分页查询机构安全帽权限信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 添加或更新机构安全帽权限信息
export function addOuHelmetPermiss(params) {
  const url = ihConfigUrl + '/newOuHelmetPermissions'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '添加或更新机构安全帽权限信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 更新机构安全帽权限信息
export function editOuHelmetPermiss(params) {
  const url = ihConfigUrl + '/ouHelmetPermissions'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '更新机构安全帽权限信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除机构安全帽权限信息
export function deleteOuHelmetPermiss(params) {
  const url = ihConfigUrl + '/ouHelmetPermissions'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '删除机构安全帽权限信息', res)
    }
    return Promise.resolve(res.data)
  })
}
export function getHelmetPermissions(params) {
  const url = ihConfigUrl + '/helmetPermissions'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '查询机构安全帽权限信息', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 获取安全帽wifi列表
 */
export function getHelmetWifi(params) {
  const url = ihConfigUrl + '/helmet/wifi/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '获取安全帽wifi列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 新增安全帽wifi信息
export function addHelmetWifi(params) {
  const url = ihConfigUrl + '/helmet/wifi/create'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '新增安全帽wifi信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除安全帽wifi信息
export function deleteHelmettWifi(params) {
  const url = ihConfigUrl + '/helmet/wifi/delete/' + params.id
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('通信配置', '删除安全帽wifi信息', res)
    }
    return Promise.resolve(res.data)
  })
}
